import { fontSizes } from 'appconstants';
import { cn } from 'lib/utils';
import Text from '../Text';
import { ReactSVG } from 'react-svg';

interface RowViewProps {
  label?: string;
  value?: any;
  className?: string;
  detailTextClassName?: string;
  icon?: string;
  onClick?: () => void;
}

const RowView = ({ label, value, className, detailTextClassName, icon, onClick }: RowViewProps) => {
  return (
    <div onClick={onClick}
      className={cn('flex justify-between gap-6 text-sm border-b py-3', className)}>
      {label && <Text text={label} size={fontSizes.h14} className='font-medium' />}

      <div className='flex items-center gap-2'>
        <Text text={value ?? '-'} className={cn('text-right text-muted-foreground', detailTextClassName)} size={fontSizes.h14} />
        {icon && <ReactSVG src={icon} />}
      </div>
    </div>
  );
};

export default RowView;
